import React, { memo } from 'react';
import { Typography } from 'fronton-react';
import { useBreakpoints } from 'common/hooks';
import { ModelJson } from 'types/model';
import { useTranslation } from 'react-i18next';
import { onMenuLinkClickCb } from './utils/ga-events';
import { AccordionItem } from './accordion';
import { FooterAccordion, FooterItemList, footerItemListTitle, FooterMenu, FooterMenuItem } from './styles';

export type FooterListProps = {
  footer: ModelJson['footer'];
};

export const FooterList = memo<FooterListProps>(({ footer }) => {
  const { t } = useTranslation();
  return (
    <>
      <FooterMenu>
        {footer && (
          <>
            <FooterListTab
              links={footer.buyers}
              metaContent="buyers"
              name={t('footer.links.headers.buyers')}
            />
            <FooterListTab
              links={footer.company}
              metaContent="companyName"
              name={t('footer.links.headers.company')}
            />
            <FooterListTab
              links={footer.business}
              metaContent="business"
              name={t('footer.links.headers.b2b')}
            />
          </>
        )}
      </FooterMenu>
    </>
  );
});
type FooterListTabProps = {
  name: string;
  metaContent: string;
  links: { label: string; link: string }[];
};

const FooterListTab: React.FC<FooterListTabProps> = ({ name, metaContent, links }) => {
  const { mobile } = useBreakpoints() || {};
  return (
    <>
      {mobile ? (
        <FooterAccordion>
          <AccordionItem key={name} title={name}>
            {links?.map(link => (
              <FooterMenuItem
                key={link.label}
                onClick={() => onMenuLinkClickCb(link.label)}
                itemProp="url"
                href={link.link}
                title={link.label}>
                <Typography variant="s" size="body_long" color="text-invert">
                  {link.label}
                </Typography>
              </FooterMenuItem>
            ))}
          </AccordionItem>
        </FooterAccordion>
      ) : (
        <FooterItemList key={name}>
          <Typography variant="m" size="subtitle" color="text-invert" className={footerItemListTitle}>
            {name}
          </Typography>
          <meta itemProp="name" content={metaContent} />

          {links?.map(link => (
            <FooterMenuItem
              key={link.label}
              onClick={() => onMenuLinkClickCb(link.label)}
              itemProp="url"
              href={link.link}
              title={link.label}>
              <Typography variant="s" size="body_long" color="text-invert">
                {link.label}
              </Typography>
            </FooterMenuItem>
          ))}
        </FooterItemList>
      )}
    </>
  );
};
